import { action, computed, observable, ObservableMap, makeObservable } from 'mobx';
import { ISODate, ISODateTime } from '../../../../../commonv3/types/dates';
import moment from 'moment-timezone';
export class CalendarViewState {
  startDate: moment.Moment;
  endDate: moment.Moment;
  currentMonth: moment.Moment;
  monthlyRows: ObservableMap<string, moment.Moment[][]> = observable.map({});
  clickableDates: Set<string> = new Set([]);

  constructor() {
    makeObservable(this, {
      startDate: observable,
      endDate: observable,
      currentMonth: observable,
      monthlyRows: observable,
      clickableDates: observable,
      currentRows: computed,
      hasPrevMonth: computed,
      hasNextMonth: computed,
      nextMonth: action.bound,
      prevMonth: action.bound,
    });
  }

  init(startDate: ISODate | moment.Moment, endDate: ISODate | moment.Moment) {
    this.monthlyRows.clear();
    this.startDate = moment(startDate).startOf('month');
    this.endDate = moment(endDate).add(-1, 'day').startOf('month');
    for (
      let currentMonth = this.startDate;
      !this.endDate.isBefore(currentMonth);
      currentMonth = moment(currentMonth).add(1, 'month')
    ) {
      this.initMonth(currentMonth);
    }
    this.currentMonth = this.startDate;
  }

  initClickableDates(clickables: ISODateTime[]) {
    this.clickableDates = new Set(clickables.map((c) => moment(c).format('YYYY-MM-DD')));
  }

  /**
   * Initializes the calendar of the given month
   * @param startOfMonth
   */
  private initMonth(startOfMonth: moment.Moment) {
    const result = [];
    const nextMonth = moment(startOfMonth).add(1, 'month');
    for (
      let w = 0;
      moment(startOfMonth)
        .day(w * 7)
        .isBefore(nextMonth);
      ++w
    ) {
      const week = [];
      for (let d = 0; d < 7; ++d) {
        week.push(moment(startOfMonth).day(w * 7 + d));
      }
      result.push(week);
    }
    this.monthlyRows.set(startOfMonth.format('YYYY-MM'), result);
  }

  get currentRows() {
    if (!this.currentMonth) {
      return [];
    }
    return this.monthlyRows.get(this.currentMonth.format('YYYY-MM'));
  }
  get hasPrevMonth() {
    if (!this.currentMonth) {
      return false;
    }
    return this.currentMonth.isAfter(this.startDate);
  }
  get hasNextMonth() {
    if (!this.currentMonth) {
      return false;
    }
    return !moment(this.currentMonth).add(1, 'month').isAfter(this.endDate);
  }

  nextMonth() {
    if (!this.hasNextMonth) {
      return;
    }
    this.currentMonth = moment(this.currentMonth).add(1, 'month');
  }

  prevMonth() {
    if (!this.hasPrevMonth) {
      return;
    }
    this.currentMonth = moment(this.currentMonth).add(-1, 'month');
  }
}
